<template>
  <div :id="`modal-gallery-images-${id}`" class="uk-flex-top uk-padding-small modal-gallery" uk-modal>
    <div class="uk-modal-dialog uk-margin-auto-vertical">
      <button class="uk-modal-close-default uk-close-large" type="button" uk-close></button>
      <div
          v-if="initData"
          :uk-slideshow="`animation: slide; index: ${ index }`"
      >
        <div
            class="uk-position-relative uk-visible-toggle uk-light"
            tabindex="-1"
        >
          <ul
              v-if="!thisDocuments"
              class="uk-slideshow-items"
              uk-height-viewport="offset-bottom: 5"
          >
            <li v-for="(file, index) in initData.files" :key="index">
              <img :src="getImage('products',  concat_path(initData, file))" :alt="file">
            </li>
          </ul>

          <ul v-else class="uk-slideshow-items document-read" uk-height-viewport="offset-bottom: 5">
            <li v-for="(item, index) in documents" :key="index">
               <span class="file-pdf">
                  <pdf
                      v-if="opened"
                      :source="documentSource(item)"
                      :page="1"
                      :width="pdfWidth"
                      @rendered="markLoaded(index)"
                  />
              </span>
              <div v-if="!loaded.includes(index)" uk-spinner></div>
              <div class="uk-overlay uk-overlay-primary uk-position-bottom uk-text-center">
                <a :href="documentSource(item)" class="uk-margin-remove" download>
                  <u>Ссылка на скачивание</u>
                </a>
              </div>
            </li>
          </ul>


          <div class="uk-hidden@s uk-light">
            <a class="uk-position-center-left uk-position-small" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
            <a class="uk-position-center-right uk-position-small" href="#" uk-slidenav-next uk-slideshow-item="next"></a>
          </div>
          <div class="uk-visible@s">
            <a class="uk-position-center-left-out uk-position-small" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
            <a class="uk-position-center-right-out uk-position-small" href="#" uk-slidenav-next uk-slideshow-item="next"></a>
          </div>
        </div>
        <ul class="uk-slideshow-nav uk-dotnav uk-flex-center"></ul>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from 'uikit'
import pdf from 'vue-pdf-embed/dist/vue2-pdf-embed'
import utils from '../utils';

export default {
  name: 'modal-gallery',
  props: {
    id: {
      default: 'single',
      type: String,
    },
    thisDocuments: {
      default: false,
      type: Boolean
    },
    index: {
      default: 0,
      type: Number
    },
    initData: null,
  },
  components: {
    pdf
  },
  data() {
    return {
      opened: false,
      loaded: [],
      pdfWidth: 720,
    }
  },
  computed: {
    documents() {
      return (this.initData && this.initData.data) || []
    },
  },
  mounted() {
    UIkit.util.on(this.$el, 'shown', this.onShown)
    UIkit.util.on(this.$el, 'hidden', this.onHidden)
  },
  beforeDestroy() {
    UIkit.util.off(this.$el, 'shown', this.onShown)
    UIkit.util.off(this.$el, 'hidden', this.onHidden)
  },
  methods: {
    getImage(type, name) {
      const { getStaticImage } = utils()
      return getStaticImage(type, name)
    },
    concat_path(article, file) {
      return `${article.id}/${file}`
    },
    documentSource(item) {
      return item.source || this.getImage('certificates', item.file_cert || item.filename)
    },
    onShown(event) {
      if (event && event.target && event.target !== this.$el) return
      const viewport = this.$el.querySelector('.uk-slideshow-items')
      const width = viewport && viewport.clientWidth
      this.pdfWidth = Math.max((width || 720) - 16, 280)
      this.loaded = []
      this.opened = true
      this.$nextTick(() => {
        const root = this.$el.querySelector('[uk-slideshow]')
        if (!root) return
        const slideshow = UIkit.slideshow(root)
        if (slideshow && typeof this.index === 'number') {
          slideshow.show(this.index)
        }
      })
    },
    onHidden(event) {
      if (event && event.target && event.target !== this.$el) return
      this.opened = false
      this.loaded = []
    },
    markLoaded(index) {
      if (!this.loaded.includes(index)) {
        this.loaded.push(index)
      }
    },
  }
}
</script>
